<div *ngIf="display" class="t-popup popup-auto-text popup-centered">
  <div class="t-popup-frame">
    <div class="t-popup-body">

      <button class="t-btn-popup-close" aria-label="close popup" (click)="doClose()"></button>

      <h2>Clinics AutoText</h2>

      <ng-container *ngIf="!selectedCategory">
        <div class="autotext-panel-categories" *ngIf="categories.length">
          <div class="autotext-panel-category" *ngFor="let c of categories" (click)="openCategory(c)">
            {{ c }}
          </div>
        </div>
        <div *ngIf="!categories.length" class="empty">No AutoText categories assigned to this template.</div>
      </ng-container>

      <ng-container *ngIf="selectedCategory">
        <button type="button" class="autotext-panel-back" (click)="backToCategories()">&larr; Back to categories</button>
        <div class="autotext-panel-category-title">{{ selectedCategory }}</div>
        <div class="autotext-panel-row" *ngFor="let s of snippetsFor(selectedCategory)" (click)="pick(s)">
          {{ s.Content }}
        </div>
      </ng-container>

    </div>
  </div>
</div>
